export const navItems = [
  {
    value: "general",
    path: "general",
  },
  {
    value: "plans",
    path: "plans",
  },
  {
    value: "billing",
    path: "billing",
  },
  {
    value: "security",
    path: "security",
  },
];
